var db = {};

db.version = '5';
db.key = 'vueMobile.database_' + db.version;

db.culture = 'en';
db.timezone = 'America/Los_Angeles';
db.textValue = '';
db.textareaValue = '';
db.checkboxValue = false;
db.dropdownValue = null;
db.radioValue = '#C0C0C0';
db.segmentedValue = 'FIRST';
db.date = null;
db.dateTime = null;
db.list = [
    {
        id: 1,
        sex: 1,
        name: 'John'
    },
    {
        id: 2,
        sex: 2,
        name: 'Sabrina'
    },
    {
        id: 3,
        sex: 1,
        name: 'Randall'
    },
    {
        id: 4,
        sex: 2,
        name: 'Lisa'
    },
    {
        id: 5,
        sex: 1,
        name: 'Gabriel'
    }
];

db.todos = [
    {
        id: 1,
        title: 'Create awesome app',
        done: true
    },
    {
        id: 2,
        title: 'Deploy it to web',
        done: false
    },
    {
        id: 3,
        title: 'Publish it to AppStore',
        done: false
    },
    {
        id: 4,
        title: 'Publish it to Google Play',
        done: false
    }
];

db.load = function () {
    let dbString;
    try {
        dbString = localStorage.getItem(db.key);
    } catch (e) {
        //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
    }

    if (dbString) {
        const data = JSON.parse(dbString);
        db.culture = data.culture;
        db.timezone = data.timezone;
        db.textValue = data.textValue;
        db.textareaValue = data.textareaValue;
        db.checkboxValue = data.checkboxValue;
        db.dropdownValue = data.dropdownValue;
        db.radioValue = data.radioValue;
        db.segmentedValue = data.segmentedValue;
        db.date = data.date;
        db.dateTime = data.dateTime;
        db.list = data.list;
        db.todos = data.todos;
    }
};

db.save = function () {
    try {
        const data = {
            culture: db.culture,
            timezone: db.timezone,
            textValue: db.textValue,
            textareaValue: db.textareaValue,
            checkboxValue: db.checkboxValue,
            dropdownValue: db.dropdownValue,
            radioValue: db.radioValue,
            segmentedValue: db.segmentedValue,
            date: db.date,
            dateTime: db.dateTime,
            list: db.list,
            todos: db.todos
        };
        localStorage.setItem(db.key, JSON.stringify(data));
    } catch (e) {
        //localstorage is not supported (it could be if external cookies are turned off and you are running app in iframe)
    }
};

db.load();

export default db;



// WEBPACK FOOTER //
// ./test/data/db.js